<ion-content [fullscreen]="true" class="viva-page control-container">

  <div class="layout-page-container">
    <div class="layout-busy-spinner" *ngIf="busyLoading">
      <viva-spinner color="white"></viva-spinner>
    </div>
    
    <viva-back-button (backClick)="dismissWithResult(false)"></viva-back-button>

    <ion-row >
      <ion-col>
        <h2> {{ 'paywall-popup.title.title' | translate }} </h2>
      </ion-col>
    </ion-row>

    <!-- Feature list -->
    <ion-list *ngIf="!isSubscribed" lines="none" class="ion-padding-horizontal">
      <ion-item>
        <ion-icon name="apps" slot="start"></ion-icon>
        <ion-label>
          <h2>{{'paywall-popup.features.feature1.name' | translate}}</h2>
          <p>{{'paywall-popup.features.feature1.description' | translate}}</p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-icon name="pulse" slot="start"></ion-icon>
        <ion-label>
          <h2>{{'paywall-popup.features.feature2.name' | translate}}</h2>
          <p>{{'paywall-popup.features.feature2.description' | translate}}</p>
        </ion-label>
      </ion-item>
    </ion-list>

    <!-- Subscription Options -->
    <div *ngIf="!isSubscribed">
      <div *ngIf="offerings" class="ion-padding-horizontal">
        <div class="subscription-options">
          <div *ngFor="let pkg of offerings.availablePackages" class="subscription-option"
            [class.selected]="selectedPackageIdentifier === pkg.identifier" (click)="selectPackage(pkg.identifier)">
            <div class="subscription-header">
              <div class="subscription-duration">
                {{ pkg.product.title }}
              </div>
              <div class="price-per-day">
                {{ pkg.product.priceString }}
              </div>
            </div>
            <!-- Badges -->
            <div *ngIf="mostPopularIdentifier === pkg.identifier" class="badge badge-popular">{{'paywall-popup.most-popular' | translate}}</div>
          </div>
        </div>

        <p class="disclaimer-text">
          {{disclaimerText}}
        </p>
        <p class="disclaimer-text" [innerHTML]="'paywall-popup.disclaimer-text-2' | translate" (click)="onDisclaimerLinkClick($event)">
        </p>
        
      </div>

    

      <ion-row>
        <ion-col>
          <ion-button class="btn-height" [disabled]="isSubscribed || !selectedPackageIdentifier || busyLoading" color="primary"
            (click)="subscribe()">
            {{'paywall-popup.buttons.subscribe' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </div>

    <!-- Subscription success -->
    <ion-row *ngIf="isSubscribed" class="ion-padding">
      <ion-col class="ion-text-center">
        <ion-icon name="checkmark-circle" color="success" size="large"></ion-icon>
        <h2 class="ion-padding-top"> {{'paywall-popup.prompts.subscription-success' | translate}} </h2>
        <p class="ion-text-wrap">{{'paywall-popup.prompts.thank-you' | translate}} </p>

        <div *ngIf="subscriptionStatus">
          <ion-text color="medium">
            <p *ngIf="subscriptionStatus.originalPurchaseDate">
              <strong>{{ 'paywall-popup.subscription.original' | translate }}:</strong>
              {{ subscriptionStatus.originalPurchaseDate | localizedDate:'mediumDate' }}
            </p>
            <p *ngIf="subscriptionStatus.purchaseDate">
              <strong>{{ 'paywall-popup.subscription.renewal' | translate }}:</strong>
              {{ subscriptionStatus.purchaseDate | localizedDate:'mediumDate' }}
            </p>
            <p *ngIf="subscriptionStatus.expirationDate">
              <strong>{{ 'paywall-popup.subscription.expires' | translate }}:</strong>
              {{ subscriptionStatus.expirationDate | localizedDate:'mediumDate' }} {{ subscriptionStatus.expirationDate |
              localizedDate:'shortTime' }}
            </p>
          </ion-text>
        </div>

        <ion-button expand="block" class="btn-height" (click)="dismissWithResult(true)" color="secondary">
          {{'paywall-popup.buttons.close' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </div>
</ion-content>